import PropTypes from 'prop-types';
import { forwardRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Collapse, Divider, IconButton, Stack, Typography, Zoom, Grow, useMediaQuery } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// ==============================|| CUSTOM SUB CARD ||============================== //

const SubCard = forwardRef(
    ({ children, content, contentClass, darkTitle, secondary, sx = {}, contentSX = {}, title, show, ...others }, ref) => {
        const theme = useTheme();
        const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
        const [Showhide, setShowhide] = useState(show);
        return (
            <Card
                ref={ref}
                sx={{
                    border: '1px solid',
                    borderColor: theme.palette.primary.light,
                    ':hover': {
                        boxShadow: '0 2px 14px 0 rgb(32 40 45 / 8%)'
                    },
                    ...sx
                }}
                {...others}
            >
                {/* card header and action */}
                {!darkTitle && title && (
                    <CardHeader
                        sx={{
                            p: 2.5,
                            flexWrap: 'wrap',
                            rowGap: 1,
                            '& .MuiCardHeader-content': { minWidth: 0, flex: '1 1 auto' },
                            '& .MuiCardHeader-action': {
                                mr: 0,
                                alignSelf: 'center',
                                '@media (max-width: 600px)': {
                                    width: '100%',
                                    margin: 0,
                                    mt: 1,
                                    alignSelf: 'stretch'
                                }
                            }
                        }}
                        title={
                            <Stack direction="row">
                                <Typography variant="h5">
                                    <IconButton
                                        onClick={() => {
                                            setShowhide(Showhide === true ? false : true);
                                        }}
                                    >
                                        {Showhide === true ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                    {/* {matchDownSM ? '' : title} */}
                                    {title}
                                </Typography>
                            </Stack>
                        }
                        action={secondary}
                    />
                )}
                {darkTitle && title && (
                    <CardHeader
                        sx={{
                            p: 2.5,
                            flexWrap: 'wrap',
                            rowGap: 1,
                            '& .MuiCardHeader-content': { minWidth: 0, flex: '1 1 auto' },
                            '& .MuiCardHeader-action': {
                                mr: 0,
                                alignSelf: 'center',
                                '@media (max-width: 600px)': {
                                    width: '100%',
                                    margin: 0,
                                    mt: 1,
                                    alignSelf: 'stretch'
                                }
                            }
                        }}
                        title={
                            <Stack direction="row">
                                <Typography variant="h4">
                                    <IconButton
                                        onClick={() => {
                                            setShowhide(Showhide === true ? false : true);
                                        }}
                                    >
                                        {Showhide === true ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                    {title}
                                </Typography>
                            </Stack>
                        }
                        action={secondary}
                    />
                )}

                {/* content & header divider */}
                {title && (
                    <Divider
                        sx={{
                            opacity: 1,
                            borderColor: theme.palette.primary.light
                        }}
                    />
                )}
                <Collapse in={Showhide}>
                    {/* card content */}
                    {content && (
                        <CardContent sx={{ p: 2.5, ...contentSX }} className={contentClass || ''}>
                            {children}
                        </CardContent>
                    )}
                    {!content && children}
                </Collapse>
            </Card>
        );
    }
);

SubCard.propTypes = {
    children: PropTypes.node,
    content: PropTypes.bool,
    contentClass: PropTypes.string,
    darkTitle: PropTypes.bool,
    secondary: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
    sx: PropTypes.object,
    contentSX: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object])
};

SubCard.defaultProps = {
    content: true
};

export default SubCard;
